import { createAsyncThunk } from "@reduxjs/toolkit";
import { getTopTalentosService } from "../../../../services/dashboard/mejoresTalentos/mejoresTalentos.services";

export const getTopTalentosThunk = createAsyncThunk(
  "mejoresTalentos/getTopTalentos",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { escuela, plantel } = getState().dashboardFilters;
      return await getTopTalentosService({ escuela, plantel });
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error obteniendo talentos"
      );
    }
  }
);